import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import {
  type ApplicationConfig,
  provideBrowserGlobalErrorListeners,
  provideZoneChangeDetection,
} from '@angular/core';
import {
  provideRouter,
  RouteReuseStrategy,
  withComponentInputBinding,
  withInMemoryScrolling,
  withPreloading,
} from '@angular/router';

import { IonicRouteStrategy, provideIonicAngular } from '@ionic/angular/standalone';

import { authInterceptor, provideAuth } from '@core/auth';
import { provideDevice } from '@core/device';
import { httpErrorInterceptor } from '@core/http';
import { provideI18n } from '@core/i18n';
import { NavPreloadStrategy } from '@core/nav';

import { provideCountdown } from '@shared/countdown';
import { provideDialog } from '@shared/dialog';
import { provideMask } from '@shared/mask';
import { provideMenu } from '@shared/menu';
import { provideToast } from '@shared/toast';
import { providerTooltip } from '@shared/tooltip';

import { provideHomeDashboard } from '@features/home/home.store';

import { routes } from './app.routes';

export const appConfig: ApplicationConfig = {
  providers: [
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    provideIonicAngular(),
    provideBrowserGlobalErrorListeners(),
    provideZoneChangeDetection({ eventCoalescing: true, runCoalescing: true }),
    provideRouter(
      routes,
      withPreloading(NavPreloadStrategy),
      withComponentInputBinding(),
      withInMemoryScrolling({
        scrollPositionRestoration: 'enabled',
        anchorScrolling: 'enabled',
      }),
    ),
    provideHttpClient(withFetch(), withInterceptors([httpErrorInterceptor, authInterceptor])),
    provideDevice(),
    provideAuth(),
    provideI18n(),
    providerTooltip(),
    provideDialog(),
    provideMenu(),
    provideToast(),
    provideCountdown(),
    provideMask(),
    provideHomeDashboard(),
  ],
};
